// extracted by mini-css-extract-plugin
module.exports = {"component":"trip-route-accordion_component__OatIn","isAccordionActive":"trip-route-accordion_isAccordionActive__7bD_f"};